module.exports = __webpack_public_path__ + "img/img_ability_cultivate_village@3x.67e80171.png";